require('./cardActivationR42Step1.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const TravelPlusPurchase = require('components/travelPlusPurchase/travelPlusPurchase');

// @ utilities
const { getTravelPlusState } = require('utilities/cardR42Helper');

// @constants
const { FIRST_STEP } = require('constants/index');
const { R42_CARD_VIP } = require('constants/cardR42States');

class CardActivationR42Step1 extends React.Component {
    render() {
        const {
            immCard,
            immCardActivationR42,
            immGlobalVariables,
            toggleHireTravelPlus,
            vip,
            travelSwitchVisible,
        } = this.props;
        const subtypeCriteria = immCard.getIn(['criteria', 'c1', 'subtipoproducto']);
        const standCriteria = immCard.getIn(['criteria', 'c1', 'estand']);
        const productContract = immCard.getIn(['contract', 'product']);
        const cardType = immCard.getIn(['product', 'type']);
        const cardSubtype = immCard.getIn(['product', 'subtype']);
        const cardStandard = immCard.getIn(['product', 'standard']);
        const isVIP = getTravelPlusState(cardType, cardSubtype, cardStandard) === R42_CARD_VIP;
        const price = immGlobalVariables.getIn(['variables', 'parameters', 'travel_plus', 'precio']);
        const priceDefaultPoeKey = formatText(`travelPlusPurchase-travelPlusPurchase_defaultPrice`);
        const pricePoeKey = formatText(`travelPlusPurchase-travelPlusPurchase_${productContract}_${subtypeCriteria}_${standCriteria}Price`);
        const priceMetalPoeKey = formatText(`travelPlusPurchase-travelPlusPurchase_metalPrice`);
        const getPoeKey = () => {
            switch (true) {
                case vip && !travelSwitchVisible:
                    return priceMetalPoeKey;
                case pricePoeKey !== '####':
                    return pricePoeKey;
                case priceDefaultPoeKey !== '####':
                    return priceDefaultPoeKey;
                default:
                    return price;
            }
        }
        const name = immCard.getIn(['alias', 'current']);

        return (
            <React.Fragment>
                <h2 className="card-activation-r42-step-1__title">
                    <FormattedText value="cardActivationR42-cardActivationR42_activationTravelPurchaseTitle" injectedStrings={[name]} />
                </h2>
                <OKMessage type="important">
                    <FormattedText value="cardActivationR42-cardActivationR42_activationTravelPurchaseMessageReceivedCardBeforeActive" />
                </OKMessage>
                <p className="card-activation-r42-step-1__description">
                    <FormattedText value="cardActivationR42-cardActivationR42_activationTravelPurchaseDescription" />
                </p>
                <TravelPlusPurchase
                    hireTravelPlus={immCardActivationR42.getIn(['steps', FIRST_STEP, 'hireTravelPlus'])}
                    isFree={isVIP}
                    getPoeKey={getPoeKey}
                    toggleHireTravelPlus={toggleHireTravelPlus}
                />
            </React.Fragment>
        );
    }
}

CardActivationR42Step1.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardActivationR42: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    toggleHireTravelPlus: PropTypes.func,
};

module.exports = CardActivationR42Step1;
